export default __webpack_public_path__ + "static/media/charlie.43cef942.jpeg";